import React from 'react';
import PropTypes from 'prop-types';
import { formatDateComponent } from '../../../../utils/formatDate';
import SubmissionFieldTime from './SubmissionFieldTime';

export default function SubmissionFieldTimestamp(props) {
  return <SubmissionFieldTime {...props} formatter={formatDateComponent} />;
}

SubmissionFieldTimestamp.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
};
